import React from 'react';
import PrivacyPolicyDoc from '../../Components/PrivacyPolicyDoc';

export const PrivacyPolicy = () => {
  return (
    <PrivacyPolicyDoc />
  )
}

export default PrivacyPolicy;